/* Laukey BW — storefront behaviour.
   Everything here is progressive: forms post and links navigate without it.
   - add to cart (cards + product page) via /cart/add.js, then the cart drawer
     is re-rendered with the Section Rendering API
   - drawer quantity links via /cart/change.js
   - card size pills, product variant picker, size guide
   - collections and search load the next page by themselves near the end (no button), reels play while on screen */
(function () {
  'use strict';

  var S = window.LaukeyTheme || {};
  var strings = S.strings || {};
  var routes = S.routes || {};
  var DRAWER_SECTION = 'cart-drawer';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- toast ---------- */
  var toast, toastT;
  function say(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toast.classList.remove('is-on'); }, 2400);
  }

  /* ---------- money (for the add button label) ---------- */
  function money(cents) {
    var fmt = S.moneyFormat || '₹{{amount}}';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var whole = parts[0];
    var last3 = whole.slice(-3), rest = whole.slice(0, -3);
    var indian = (rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' : '') + last3;
    var western = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return western;
      if (key === 'amount_no_decimals_with_comma_separator') return whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (key === 'amount_with_comma_separator') return western.replace(/,/g, '.') + ',' + parts[1];
      if (key === 'amount_with_indian_commas' || key === 'amount_no_decimals_with_indian_commas') return indian;
      return western + '.' + parts[1];
    });
  }

  /* ---------- cart drawer ---------- */
  var lastFocus = null;
  function drawer() { return $('[data-cart-drawer]'); }
  function openCart() {
    var d = drawer();
    if (!d) { window.location.href = routes.cart || '/cart'; return; }
    lastFocus = document.activeElement;
    document.body.classList.add('cart-open');
    d.setAttribute('aria-hidden', 'false');
    setTimeout(function () { d.focus(); }, 30);
  }
  function closeCart() {
    var d = drawer();
    if (!d) return;
    document.body.classList.remove('cart-open');
    d.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (x) { x.textContent = n; x.setAttribute('data-count', n); });
  }
  function swapDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer]', doc);
    var d = drawer();
    if (fresh && d) d.innerHTML = fresh.innerHTML;
  }
  function refreshCount() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; });
  }

  function addToCart(form, opts) {
    opts = opts || {};
    var btn = $('[type="submit"][name="add"]', form);
    var err = $('[data-form-error]', form);
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    if (err) err.hidden = true;
    var body = new FormData(form);
    body.append('sections', DRAWER_SECTION);
    body.append('sections_url', window.location.pathname);
    return fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) {
          var msg = res.j.description || res.j.message || strings.addError;
          if (opts.onError) opts.onError(msg);
          else if (err) { err.textContent = msg; err.hidden = false; } else { say(msg); }
          return;
        }
        if (opts.checkout) { window.location.href = routes.checkout || '/checkout'; return; }
        if (opts.onAdded) opts.onAdded();
        if (res.j.sections) swapDrawer(res.j.sections[DRAWER_SECTION]);
        refreshCount();
        var addedCard = cardOf(form);
        if (addedCard) {
          addedCard.classList.remove('has-size');
          $$('[data-size-pill]', addedCard).forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        }
        if (S.cartType === 'page') { window.location.href = routes.cart || '/cart'; return; }
        if (drawer()) openCart(); else say(strings.added);
      })
      .catch(function () { if (opts.onError) opts.onError(strings.addError); else if (err) { err.textContent = strings.addError; err.hidden = false; } else { say(strings.addError); } })
      .then(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = btn.hasAttribute('data-unavailable'); }
      });
  }

  function changeLine(line, quantity) {
    var d = drawer();
    if (d) d.classList.add('is-busy');
    return fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: [DRAWER_SECTION], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status) { say(j.description || j.message || strings.addError); return; }
        if (j.sections) swapDrawer(j.sections[DRAWER_SECTION]);
        setCount(j.item_count);
      })
      .catch(function () { say(strings.addError); })
      .then(function () { var dd = drawer(); if (dd) dd.classList.remove('is-busy'); });
  }

  /* ---------- product page ---------- */
  function initProduct(section) {
    var json = $('[data-product-json]', section);
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (e) { return; }
    var form = $('form.js-product-form', section);
    var input = form && $('[data-variant-input]', form);
    var addBtn = form && $('[data-add-button]', form);
    var price = $('[data-price]', section);
    var sizer = $('[data-sizer]', section);
    var unit = 'in';
    var measures = null;
    if (sizer) {
      var m = $('[data-measures]', sizer);
      try { measures = m ? JSON.parse(m.textContent) : null; } catch (e) { measures = null; }
    }
    var fieldsets = $$('fieldset[data-option-index]', section);
    var selected = (function () {
      var v = product.variants.filter(function (x) { return String(x.id) === (input ? input.value : ''); })[0] || product.variants[0];
      return v ? v.options.slice() : [];
    })();

    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function updateAvailability() {
      fieldsets.forEach(function (fs) {
        var idx = Number(fs.getAttribute('data-option-index'));
        $$('[data-option-button]', fs).forEach(function (b) {
          var probe = selected.slice();
          probe[idx] = b.getAttribute('data-option-button');
          var v = findVariant(probe);
          b.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function renderSizer() {
      if (!sizer || !measures) return;
      var rows = measures[unit] || measures.in || [];
      var sizeFs = fieldsets.filter(function (fs) { return fs.querySelector('.size-btn'); })[0];
      var label = sizeFs ? selected[Number(sizeFs.getAttribute('data-option-index'))] : '';
      var row = rows.filter(function (r) { return r[0] && r[0].toLowerCase() === String(label).toLowerCase(); })[0] || rows[0];
      var sl = $('[data-size-label]', sizer);
      if (sl) sl.textContent = row ? row[0] : label;
      $$('[data-measure]', sizer).forEach(function (cell) {
        var i = Number(cell.getAttribute('data-measure'));
        cell.textContent = row && row[i] ? row[i] : '—';
      });
      $$('[data-unit]', sizer).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-unit') === unit)); });
    }

    function apply() {
      var v = findVariant(selected);
      fieldsets.forEach(function (fs) {
        var idx = Number(fs.getAttribute('data-option-index'));
        $$('[data-option-button]', fs).forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-option-button') === selected[idx]));
        });
        var lbl = $('[data-option-value]', fs);
        if (lbl) lbl.textContent = selected[idx];
      });
      $$('[data-colour-name]', section).forEach(function (n) {
        var fs = fieldsets.filter(function (f) { return f.querySelector('.swatch'); })[0];
        if (fs) n.textContent = selected[Number(fs.getAttribute('data-option-index'))];
      });
      updateAvailability();
      renderSizer();
      if (!addBtn) return;
      if (!v) {
        addBtn.disabled = true; addBtn.setAttribute('data-unavailable', '');
        addBtn.textContent = strings.unavailable;
        return;
      }
      if (input) input.value = v.id;
      if (price) {
        price.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
      }
      if (v.available) {
        addBtn.disabled = false; addBtn.removeAttribute('data-unavailable');
        addBtn.textContent = addBtn.getAttribute('data-show-price') === 'false' ? strings.addToCart : strings.addToCartPrice.replace('[price]', money(v.price));
      } else {
        addBtn.disabled = true; addBtn.setAttribute('data-unavailable', '');
        addBtn.textContent = strings.soldOut;
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (v.featured_media) {
        var item = $('[data-media-id="' + v.featured_media.id + '"]', section);
        if (item && item.getBoundingClientRect().top > window.innerHeight) item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    section.addEventListener('click', function (e) {
      var b = e.target.closest('[data-option-button]');
      if (b) {
        var fs = b.closest('fieldset[data-option-index]');
        selected[Number(fs.getAttribute('data-option-index'))] = b.getAttribute('data-option-button');
        apply();
        return;
      }
      var t = e.target.closest('[data-sizer-toggle]');
      if (t && sizer) {
        sizer.hidden = !sizer.hidden;
        t.setAttribute('aria-expanded', String(!sizer.hidden));
        return;
      }
      var u = e.target.closest('[data-unit]');
      if (u) { unit = u.getAttribute('data-unit'); renderSizer(); }
    });

    if (addBtn && addBtn.disabled) addBtn.setAttribute('data-unavailable', '');
    updateAvailability();
    renderSizer();
  }

  /* ---------- recommendations ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  /* ---------- load more ---------- */
  function loadMore(link) {
    var grid = $('[data-grid]');
    if (!grid) return false;
    link.setAttribute('aria-busy', 'true');
    fetch(link.href).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var more = $('[data-grid]', doc);
      if (more) $$(':scope > li', more).forEach(function (li) { grid.appendChild(li); });
      var next = $('[data-load-more]', doc);
      if (next) { link.href = next.href; link.textContent = next.textContent; link.removeAttribute('aria-busy'); }
      else { link.parentNode.removeChild(link); }
    }).catch(function () { link.removeAttribute('aria-busy'); });
    return true;
  }
  /* no "load more" clicks: fetch the next page as the visitor nears the end */
  function initAutoMore() {
    $$('[data-auto-more]').forEach(function (box) {
      if (box.__auto || !('IntersectionObserver' in window)) return;
      box.__auto = true;
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        var link = $('[data-load-more]', box);
        if (!link) { io.disconnect(); return; }
        if (link.getAttribute('aria-busy') !== 'true') loadMore(link);
      }, { rootMargin: '800px 0px' });
      io.observe(box);
    });
  }

  /* ---------- videos: shared play helper (iPhone-safe) ----------
     iPhones only auto-play videos that are muted + inline, and refuse
     entirely in Low Power Mode. Refused videos are retried on the visitor's
     first tap/scroll-tap, which iOS counts as permission. "Reduce Motion"
     shows still frames only when Theme settings > Videos says so. */
  var videosStill = !!(window.LaukeyTheme && window.LaukeyTheme.videoStill) &&
    !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var blockedVideos = [];
  function retryBlocked() {
    var list = blockedVideos; blockedVideos = [];
    list.forEach(function (v) {
      var r = v.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight && v.paused) playVideo(v);
    });
  }
  ['touchend', 'click', 'keydown'].forEach(function (ev) { document.addEventListener(ev, retryBlocked, { passive: true }); });
  /* iPhone Safari freezes videos when the visitor switches apps, locks the
     phone or comes back to the page with the back button (page cache), and
     does not restart them. Restart whatever should be playing. */
  function resumeVideos() {
    if (videosStill || document.hidden) return;
    $$('video').forEach(function (v) {
      if (!v.paused || v.__userPaused || v.__img || v.hasAttribute('controls')) return;
      if (v.hasAttribute('data-hero-video') || v.__inview) playVideo(v);
    });
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) setTimeout(resumeVideos, 60); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) setTimeout(resumeVideos, 60); });
  window.addEventListener('focus', function () { setTimeout(resumeVideos, 60); });
  /* Safari (every iPhone browser) may refuse to play videos, e.g. in Low
     Power Mode. Safari can show an MP4 inside an <img>, where it loops like
     a GIF and is not blocked, so a refused video is swapped for that. */
  var ua = navigator.userAgent || '';
  var isAppleWebKit = /iPhone|iPad|iPod/.test(ua) || (/AppleWebKit/.test(ua) && /Safari/.test(ua) && !/Chrome|Chromium|CriOS|Edg|OPR|Android/.test(ua));
  function mp4For(v) {
    /* lightest copy first: the image version streams the whole file */
    var wide = window.matchMedia && window.matchMedia('(min-width: 821px)').matches;
    var lite = (wide && v.getAttribute('data-fallback-src-desktop')) || v.getAttribute('data-fallback-src');
    if (lite) return lite;
    var pick = null;
    $$('source', v).forEach(function (s) {
      if (pick || !/mp4/.test(s.getAttribute('type') || '')) return;
      var media = s.getAttribute('media');
      if (!media || (window.matchMedia && window.matchMedia(media).matches)) pick = s.src;
    });
    return pick || (/\.mp4/.test(v.currentSrc || '') ? v.currentSrc : null);
  }
  function imageFallback(v) {
    if (v.__img) return true;
    if (v.__imgFailed) return false;
    var src = mp4For(v);
    if (!src) return false;
    var img = document.createElement('img');
    img.className = 'video-img';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.decoding = 'async';
    /* only swap once the image version really shows; otherwise keep the
       video (and its preview frame) and wait for a tap */
    img.onload = function () { img.classList.add('is-ready'); v.style.visibility = 'hidden'; };
    img.onerror = function () {
      if (img.parentNode) img.parentNode.removeChild(img);
      v.__img = null; v.__imgFailed = true; v.style.visibility = '';
      if (blockedVideos.indexOf(v) < 0) blockedVideos.push(v);
    };
    img.src = src;
    v.parentNode.insertBefore(img, v.nextSibling);
    v.__img = img;
    return true;
  }
  function playVideo(v) {
    if (videosStill) return;
    if (v.__img) return;
    v.muted = true; v.defaultMuted = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    if (v.preload === 'none') v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) p.catch(function (err) {
      /* AbortError just means it was paused again (scrolled away) — not a block */
      if (!err || err.name !== 'NotAllowedError') return;
      if (isAppleWebKit && imageFallback(v)) return;
      if (blockedVideos.indexOf(v) < 0) blockedVideos.push(v);
    });
  }

  /* ---------- reels: play while visible ---------- */
  function initReels() {
    var vids = $$('.reel video');
    if (!vids.length || videosStill || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        v.__inview = en.isIntersecting;
        if (en.isIntersecting) playVideo(v);
        else v.pause();
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); io.observe(v); });
  }

  /* ---------- hero video: pause button, honour reduced motion ---------- */
  function initHeroVideos(root) {
    $$('[data-hero-video]', root).forEach(function (v) {
      var hero = v.closest('.lk-hero');
      var btn = hero && $('[data-hero-pause]', hero);
      function sync() {
        if (!btn) return;
        btn.setAttribute('aria-pressed', String(v.paused));
        btn.setAttribute('aria-label', v.paused ? strings.play : strings.pause);
      }
      if (videosStill) { v.removeAttribute('autoplay'); v.pause(); }
      else {
        playVideo(v);
        /* pause while scrolled away so the phone isn't decoding a hidden
           1080p stream next to the reels; resume when it comes back */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) {
            v.__inview = es[0].isIntersecting;
            if (v.__inview) { if (v.paused && !v.__userPaused) playVideo(v); }
            else if (!v.paused) v.pause();
          }, { threshold: 0.05 }).observe(v);
        }
      }
      v.addEventListener('play', sync);
      v.addEventListener('pause', sync);
      if (btn) btn.addEventListener('click', function () {
        if (v.paused) { v.__userPaused = false; var q = v.play(); if (q && q.catch) q.catch(function () {}); } else { v.__userPaused = true; v.pause(); }
      });
      sync();
    });
  }

  /* ---------- product card videos: play only while on screen ---------- */
  var cardVideoIO = null;
  function initCardVideos(root) {
    var reduce = videosStill;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    var play = playVideo;
    if (!cardVideoIO && 'IntersectionObserver' in window) {
      cardVideoIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          v.__inview = en.isIntersecting;
          if (en.isIntersecting) play(v); else v.pause();
        });
      }, { threshold: 0.35 });
    }
    $$('[data-card-video]', root).forEach(function (box) {
      if (box.hasAttribute('data-ready')) return;
      box.setAttribute('data-ready', '');
      var v = $('video', box);
      if (!v) return;
      v.muted = true;
      v.setAttribute('playsinline', '');
      var mode = box.getAttribute('data-card-video');
      if (mode === 'hover') {
        if (!canHover) return; /* phones/tablets: photos only */
        var card = box.closest('[data-card]') || box;
        card.addEventListener('mouseenter', function () { box.classList.add('is-on'); play(v); });
        card.addEventListener('mouseleave', function () { box.classList.remove('is-on'); v.pause(); try { v.currentTime = 0; } catch (e) {} });
        return;
      }
      if (reduce) return;
      if (cardVideoIO) cardVideoIO.observe(v); else play(v);
    });
    /* other on-screen-only videos (product gallery, film, waitlist) */
    $$('video[data-inview-video]', root).forEach(function (v) {
      if (v.hasAttribute('data-ready')) return;
      v.setAttribute('data-ready', '');
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (reduce) return;
      if (cardVideoIO) cardVideoIO.observe(v); else play(v);
    });
  }
  /* cards added later (load more, recommendations, editor) */
  if ('MutationObserver' in window) {
    var cardVideoTimer = null;
    new MutationObserver(function () {
      clearTimeout(cardVideoTimer);
      cardVideoTimer = setTimeout(function () { initCardVideos(document); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- banner carousel (collection banner slides) ---------- */
  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (car) {
      if (car.hasAttribute('data-ready')) return;
      car.setAttribute('data-ready', '');
      var slides = $$('[data-slide]', car);
      if (slides.length < 2) return;
      var dots = $$('[data-carousel-dot]', car);
      var num = $('[data-carousel-num]', car);
      var i = 0, timer = null, paused = false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var auto = car.getAttribute('data-autoplay') === 'true' && !reduce;
      var ms = Math.max(3, Number(car.getAttribute('data-interval')) || 5) * 1000;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          var on = k === i;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
          $$('a', s).forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
        });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', String(k === i)); d.classList.toggle('is-done', k < i); });
        if (num) num.textContent = (i < 9 ? '0' : '') + (i + 1);
        restartBar();
      }
      /* the current progress bar fills over the slide time; restart it on every change */
      function restartBar() {
        if (!auto || paused) return;
        car.classList.remove('cb-run'); void car.offsetWidth; car.classList.add('cb-run');
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { stop(); if (auto && !paused) { timer = setInterval(function () { go(i + 1); }, ms); restartBar(); } }
      if (!auto) car.classList.add('cb-static');
      car.addEventListener('click', function (e) {
        if (e.target.closest('[data-carousel-prev]')) { go(i - 1); start(); }
        else if (e.target.closest('[data-carousel-next]')) { go(i + 1); start(); }
        else { var d = e.target.closest('[data-carousel-dot]'); if (d) { go(Number(d.getAttribute('data-carousel-dot'))); start(); } }
      });
      car.addEventListener('mouseenter', function () { paused = true; stop(); car.classList.add('is-paused'); });
      car.addEventListener('mouseleave', function () { paused = false; car.classList.remove('is-paused'); start(); });
      car.addEventListener('focusin', function () { paused = true; stop(); });
      car.addEventListener('focusout', function (e) { if (!car.contains(e.relatedTarget)) { paused = false; start(); } });
      var x0 = null;
      car.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') x0 = e.clientX; });
      car.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); start(); }
      });
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      /* theme editor: selecting a slide block shows it */
      car.__go = function (n) { paused = true; stop(); go(n); };
      start();
    });
  }
  document.addEventListener('shopify:block:select', function (e) {
    var car = e.target.closest && e.target.closest('[data-carousel]');
    if (car && car.__go) car.__go($$('[data-slide]', car).indexOf(e.target));
  });

  /* ---------- phone menu (hamburger) ---------- */
  var menuReturn = null;
  function menuEl() { return $('[data-menu-drawer]'); }
  function openMenu() {
    var m = menuEl(); if (!m) return;
    menuReturn = document.activeElement;
    m.hidden = false;
    document.body.classList.add('menu-open');
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    void m.offsetWidth; /* commit the unhidden state so the slide-in animates */
    m.classList.add('is-open');
    var p = $('.menu-drawer__panel', m); if (p) p.focus({ preventScroll: true });
  }
  function closeMenu() {
    var m = menuEl(); if (!m || m.hidden) return;
    m.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () { m.hidden = true; }, reduce ? 0 : 320);
    if (menuReturn && menuReturn.focus) menuReturn.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (e.target.closest('[data-menu-close]')) { closeMenu(); return; }
    var link = e.target.closest('.menu-drawer a[href]');
    if (link) closeMenu();
  });
  window.addEventListener('resize', function () { if (window.innerWidth > 820) closeMenu(); });

  /* ---------- header: hide while scrolling down, show on scroll up ---------- */
  function initSmartHeader() {
    var header = $('[data-header][data-sticky-mode="smart"]');
    var wrap = header && header.closest('.section-header');
    if (!wrap || wrap.hasAttribute('data-smart')) return;
    wrap.setAttribute('data-smart', '');
    var lastY = window.scrollY;
    function busy() {
      return document.body.classList.contains('menu-open') || document.body.classList.contains('cart-open') ||
        !!$('[data-nav-item].is-open') || !!$('[data-nav-item]:hover');
    }
    function update() {
      var y = Math.max(0, window.scrollY);
      var h = wrap.offsetHeight;
      if (Math.abs(y - lastY) < 6) return;
      if (y > lastY && y > h + 40 && !busy()) wrap.classList.add('is-hidden');
      else if (y < lastY || y <= h) wrap.classList.remove('is-hidden');
      lastY = y;
    }
    window.addEventListener('scroll', update, { passive: true });
    wrap.addEventListener('focusin', function () { wrap.classList.remove('is-hidden'); });
  }

  /* ---------- size chart: unit switch + highlight the picked size ---------- */
  function chartPick(label) {
    var key = String(label || '').trim().toLowerCase();
    $$('[data-size-chart] [data-size-row]').forEach(function (tr) {
      tr.classList.toggle('is-picked', key !== '' && tr.getAttribute('data-size-row') === key);
    });
  }
  function initSizeChart() {
    var picked = $('.size-btn[aria-pressed="true"]');
    if (picked) chartPick(picked.getAttribute('data-option-button'));
  }
  document.addEventListener('click', function (e) {
    var u = e.target.closest('[data-chart-unit]');
    if (u) {
      var chart = u.closest('[data-size-chart]');
      var unit = u.getAttribute('data-chart-unit');
      $$('[data-chart-unit]', chart).forEach(function (b) { b.setAttribute('aria-pressed', String(b === u)); });
      $$('[data-chart-table]', chart).forEach(function (t) { t.hidden = t.getAttribute('data-chart-table') !== unit; });
      return;
    }
    var sb = e.target.closest('.size-btn[data-option-button]');
    if (sb) chartPick(sb.getAttribute('data-option-button'));
  });

  /* ---------- nav dropdowns ----------
     Desktop: CSS opens on hover/focus; we mirror aria-expanded.
     Touch: first tap on the parent opens the panel, second tap follows the link. */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function setHeaderBottom() {
    var h = $('[data-header]');
    if (h) document.documentElement.style.setProperty('--header-bottom', Math.round(h.getBoundingClientRect().bottom + 8) + 'px');
  }
  function closeNav(except) {
    $$('[data-nav-item].is-open').forEach(function (n) {
      if (n === except) return;
      n.classList.remove('is-open');
      var a = $('.nav-item__link', n); if (a) a.setAttribute('aria-expanded', 'false');
    });
  }
  function initNav() {
    $$('[data-nav-item]').forEach(function (item) {
      if (item.hasAttribute('data-nav-ready')) return;
      item.setAttribute('data-nav-ready', '');
      var link = $('.nav-item__link', item);
      if (!link) return;
      /* picture panel follows the link being pointed at */
      var rows = $$('.nav-drop__link[data-pane]', item);
      var panes = $$('.nav-drop__pane[data-pane]', item);
      function showPane(i) {
        rows.forEach(function (r) { r.classList.toggle('is-active', r.getAttribute('data-pane') === i); });
        panes.forEach(function (p) {
          var on = p.getAttribute('data-pane') === i;
          p.classList.toggle('is-active', on);
          if (on) p.removeAttribute('aria-hidden'); else p.setAttribute('aria-hidden', 'true');
        });
      }
      if (panes.length) {
        rows.forEach(function (r) {
          var i = r.getAttribute('data-pane');
          r.addEventListener('mouseenter', function () { showPane(i); });
          r.addEventListener('focus', function () { showPane(i); });
        });
        item.addEventListener('mouseleave', function () { showPane(rows[0].getAttribute('data-pane')); });
      }
      item.addEventListener('mouseenter', function () { if (canHover) link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('mouseleave', function () { if (canHover) { link.setAttribute('aria-expanded', 'false'); item.classList.remove('is-open'); } });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); } });
      link.addEventListener('click', function (e) {
        if (canHover) return;
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          setHeaderBottom();
          closeNav(item);
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        }
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true');
          var first = $('.nav-drop a', item); if (first) first.focus();
        }
      });
    });
  }

  /* ---------- horizontal scrollers with arrows (reels) ---------- */
  function initScrollers(root) {
    $$('[data-scroll-arrows]', root).forEach(function (wrap) {
      var track = document.getElementById(wrap.getAttribute('data-scroll-arrows'));
      if (!track || wrap.hasAttribute('data-ready')) return;
      wrap.setAttribute('data-ready', '');
      var prev = $('[data-scroll-dir="-1"]', wrap), next = $('[data-scroll-dir="1"]', wrap);
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        wrap.hidden = max <= 4;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
      }
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-scroll-dir]');
        if (!b) return;
        var item = track.querySelector('[data-scroll-item]') || track.firstElementChild;
        var cs = window.getComputedStyle(track);
        var gap = parseFloat(cs.columnGap) || 14;
        var w = item ? item.getBoundingClientRect().width : 0;
        var step = w ? w + gap : track.clientWidth * 0.8;
        var per = Math.max(1, Math.floor(track.clientWidth / step));
        track.scrollBy({ left: Number(b.getAttribute('data-scroll-dir')) * step * per, behavior: 'smooth' });
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- events ---------- */
  /* ---------- card sizes: hover pills (desktop) + size sheet ---------- */
  var sheet, sheetCard, sheetReturn;
  function cardOf(el) { return el.closest('[data-card]'); }
  function pickSize(card, pill) {
    var form = $('form.js-product-form', card);
    var inp = form && $('[data-variant-input]', form);
    if (inp) inp.value = pill.getAttribute('data-size-pill');
    $$('[data-size-pill]', card).forEach(function (p) { p.setAttribute('aria-pressed', String(p === pill)); });
    card.classList.add('has-size');
    return form;
  }
  function sheetPick() { return sheet && $('[data-sheet-size][aria-pressed="true"]', sheet); }
  function sheetState(msg) {
    if (!sheet) return;
    var needs = $$('[data-sheet-size]', sheet).length > 0;
    var ready = !needs || !!sheetPick();
    $$('[data-sheet-action]', sheet).forEach(function (b) { b.setAttribute('aria-disabled', String(!ready)); });
    var err = $('[data-sheet-error]', sheet);
    if (err) { err.textContent = msg || ''; err.hidden = !msg; }
  }
  function openSheet(card, returnTo) {
    sheet = sheet || $('[data-size-sheet]');
    if (!sheet) return false;
    sheetCard = card;
    sheetReturn = returnTo || null;
    var title = $('[data-size-sheet-title]', sheet);
    var price = $('[data-size-sheet-price]', sheet);
    var box = $('[data-size-sheet-sizes]', sheet);
    var label = $('[data-size-sheet-label]', sheet);
    if (title) title.textContent = card.getAttribute('data-title') || '';
    var p = $('.card__price', card);
    if (price) price.innerHTML = p ? p.innerHTML : '';
    box.innerHTML = '';
    var pills = $$('[data-size-pill]', card);
    pills.forEach(function (pill) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'size-btn' + (pill.disabled ? ' is-unavailable' : '');
      b.textContent = pill.getAttribute('data-size-label') || pill.textContent;
      b.setAttribute('data-sheet-size', pill.getAttribute('data-size-pill'));
      b.setAttribute('aria-pressed', String(pill.getAttribute('aria-pressed') === 'true' && !pill.disabled));
      if (pill.disabled) b.disabled = true;
      box.appendChild(b);
    });
    if (label) label.hidden = pills.length === 0;
    box.hidden = pills.length === 0;
    $$('[data-sheet-action]', sheet).forEach(function (b) { b.removeAttribute('aria-busy'); });
    sheetState('');
    sheet.hidden = false;
    document.body.style.overflow = 'hidden';
    var first = sheetPick() || $('[data-sheet-size]:not([disabled])', box) || $('[data-sheet-action]', sheet);
    setTimeout(function () { (first || $('.sizesheet__panel', sheet)).focus(); }, 30);
    return true;
  }
  function closeSheet(restoreFocus) {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    document.body.style.overflow = '';
    if (restoreFocus !== false && sheetReturn && sheetReturn.focus) sheetReturn.focus();
    sheetCard = null;
  }
  function sheetSubmit(checkout) {
    var card = sheetCard;
    if (!card) return;
    var needs = $$('[data-sheet-size]', sheet).length > 0;
    var picked = sheetPick();
    if (needs && !picked) { sheetState(strings.selectSize); return; }
    var form = $('form.js-product-form', card);
    if (picked) {
      var match = $$('[data-size-pill]', card).filter(function (p) { return p.getAttribute('data-size-pill') === picked.getAttribute('data-sheet-size'); })[0];
      if (match) form = pickSize(card, match);
    }
    if (!form) return;
    var btns = $$('[data-sheet-action]', sheet);
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    addToCart(form, {
      checkout: checkout,
      onAdded: function () { closeSheet(false); },
      onError: function (msg) { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); sheetState(msg); }
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('js-product-form')) return;
    if (!window.fetch || !window.FormData) return;
    var card = cardOf(form);
    var opener = $('[data-open-sheet]', form);
    if (card && opener && openSheet(card, opener)) { e.preventDefault(); return; }
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-size-pill]');
    if (pill) {
      var c = cardOf(pill);
      if (c) pickSize(c, pill);
      return;
    }
    var ss = e.target.closest('[data-sheet-size]');
    if (ss && sheetCard) {
      $$('[data-sheet-size]', sheet).forEach(function (b) { b.setAttribute('aria-pressed', String(b === ss)); });
      sheetState('');
      return;
    }
    var act = e.target.closest('[data-sheet-action]');
    if (act && sheetCard) {
      if (act.getAttribute('aria-busy') === 'true') return;
      sheetSubmit(act.getAttribute('data-sheet-action') === 'checkout');
      return;
    }
    if (e.target.closest('[data-size-sheet-close]')) { closeSheet(); return; }
    if (e.target.closest('[data-open-cart]') && drawer() && S.cartType !== 'page') {
      e.preventDefault(); openCart(); return;
    }
    if (e.target.closest('[data-close-cart]')) { closeCart(); return; }
    var ch = e.target.closest('[data-cart-change]');
    if (ch && ch.closest('[data-cart-drawer]')) {
      e.preventDefault();
      changeLine(Number(ch.getAttribute('data-line')), Number(ch.getAttribute('data-quantity')));
      return;
    }
    var lm = e.target.closest('[data-load-more]');
    if (lm && loadMore(lm)) { e.preventDefault(); return; }
    var fv = e.target.closest('[data-fit-video]');
    if (fv) {
      var dlg = document.getElementById(fv.getAttribute('data-fit-video'));
      if (dlg && dlg.showModal) {
        dlg.showModal();
        var vid = dlg.querySelector('video');
        if (vid) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
      }
      return;
    }
    var fc = e.target.closest('[data-fit-close]');
    if (fc || (e.target.matches && e.target.matches('dialog.fitvid'))) {
      var d = fc ? fc.closest('dialog') : e.target;
      if (d && d.open) d.close();
      return;
    }
    var pv = e.target.closest('[data-play-video]');
    if (pv) {
      var box = $('[data-film="' + pv.getAttribute('data-play-video') + '"] video');
      if (box) { box.play(); box.focus(); }
    }
  });

  /* ---------- pop-up dialogs (full size chart) ---------- */
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-dialog-open]');
    if (op) {
      var dlg = document.getElementById(op.getAttribute('data-dialog-open'));
      if (dlg && dlg.showModal) {
        /* highlight the size picked on the page */
        var sec = op.closest('[data-product-section]');
        var picked = sec && $('[data-size-label]', sec);
        var val = picked ? picked.textContent.trim() : '';
        $$('[data-chart-row]', dlg).forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-chart-row') === val); });
        dlg.showModal();
      }
      return;
    }
    var cl = e.target.closest('[data-dialog-close]');
    if (cl) { var d0 = cl.closest('dialog'); if (d0) d0.close(); return; }
    if (e.target.matches && e.target.matches('dialog.chartdlg')) { e.target.close(); return; }
    var u = e.target.closest('[data-chart-unit]');
    if (u) {
      var box = u.closest('[data-chart]'), unit = u.getAttribute('data-chart-unit');
      $$('[data-chart-unit]', box).forEach(function (b) { b.setAttribute('aria-pressed', String(b === u)); });
      $$('[data-chart-table]', box).forEach(function (t) { t.hidden = t.getAttribute('data-chart-table') !== unit; });
    }
  });

  /* ---------- swipe dots: show position in a sideways scroller (phones) ---------- */
  function initScrollDots(root) {
    $$('[data-scroll-dots]', root).forEach(function (wrap) {
      if (wrap.hasAttribute('data-ready')) return;
      var track = document.getElementById(wrap.getAttribute('data-scroll-dots'));
      if (!track) return;
      var items = $$(wrap.getAttribute('data-dots-items') || ':scope > *', track);
      if (items.length < 2) { wrap.hidden = true; return; }
      wrap.setAttribute('data-ready', '');
      wrap.innerHTML = '';
      var dots = items.map(function (item, k) {
        var b = document.createElement('button');
        b.type = 'button'; b.tabIndex = -1; b.className = 'scroll-dot';
        b.addEventListener('click', function () {
          track.scrollTo({ left: track.scrollLeft + item.getBoundingClientRect().left - track.getBoundingClientRect().left - (parseFloat(getComputedStyle(track).paddingLeft) || 0), behavior: 'smooth' });
        });
        wrap.appendChild(b);
        return b;
      });
      function update() {
        var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        var left = track.getBoundingClientRect().left + pad, best = 0, bestD = Infinity;
        items.forEach(function (it, k) { var d = Math.abs(it.getBoundingClientRect().left - left); if (d < bestD) { bestD = d; best = k; } });
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = items.length - 1;
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === best); });
      }
      var t = null;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 40); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- complete the set + floating "scroll below" tag ---------- */
  function initCompleteSet(el) {
    var url = el.getAttribute('data-url');
    if (!url || el.hasAttribute('data-ready')) return;
    el.setAttribute('data-ready', '');
    var jump = document.querySelector('[data-set-jump="' + el.id + '"]');
    function arm() {
      if (!jump || !$('.card', el)) return;
      jump.hidden = false;
      jump.addEventListener('click', function (e) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      /* hide the tag once the set is on screen or already scrolled past */
      function sync() {
        var r = el.getBoundingClientRect();
        jump.classList.toggle('is-gone', r.top < window.innerHeight * 0.85);
      }
      window.addEventListener('scroll', sync, { passive: true });
      sync();
    }
    if ($('.card', el)) { arm(); return; }
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-complete-set]', doc);
      if (fresh && $('.card', fresh)) { el.innerHTML = fresh.innerHTML; arm(); }
    }).catch(function () {});
  }

  /* sort menu / filter panel: close on outside click or Esc */
  document.addEventListener('click', function (e) {
    $$('details.sortmenu[open], details.filters[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('details.sortmenu[open], details.filters[open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary'); if (s) s.focus();
    });
  });

  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('dialog.fitvid')) {
      var v = e.target.querySelector('video');
      if (v) v.pause();
    }
  }, true);

  document.addEventListener('change', function (e) {
    var f = e.target.closest('form[data-auto-submit]');
    if (f) f.submit();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menuEl() && !menuEl().hidden) { closeMenu(); return; }
    if (e.key === 'Escape' && sheet && !sheet.hidden) { closeSheet(); return; }
    if (e.key === 'Escape' && $('[data-nav-item].is-open')) {
      var openItem = $('[data-nav-item].is-open'); closeNav(); var l = $('.nav-item__link', openItem); if (l) l.focus(); return;
    }
    if (e.key === 'Escape' && document.body.classList.contains('cart-open')) closeCart();
    if (e.key === 'Escape') {
      $$('details.filters[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  /* close the filter panel / nav dropdown when clicking elsewhere */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-item]')) closeNav();
    $$('details.filters[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* header height (incl. announcement bar) for the fit-to-screen hero */
  function setHeaderHeight() {
    var g = $('.section-header');
    var bottom = 0;
    $$('#shopify-section-header-group, .shopify-section-group-header-group').forEach(function (s) {
      bottom = Math.max(bottom, s.getBoundingClientRect().bottom + window.scrollY);
    });
    if (!bottom && g) bottom = g.getBoundingClientRect().bottom + window.scrollY;
    if (bottom) document.documentElement.style.setProperty('--header-h', Math.round(bottom) + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  function boot() {
    $$('[data-product-section]').forEach(initProduct);
    $$('[data-recommendations]').forEach(initRecommendations);
    initReels();
    initHeroVideos(document);
    initNav();
    initScrollers(document);
    setHeaderHeight();
    initSizeChart();
    initSmartHeader();
    initCarousels(document);
    initAutoMore();
    initCardVideos(document);
    initScrollDots(document);
    $$('[data-complete-set]').forEach(initCompleteSet);
    if (window.location.hash === '#cart' && drawer()) openCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* theme editor: re-init a section when it's re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-section]', e.target).forEach(initProduct);
    $$('[data-recommendations]', e.target).forEach(initRecommendations);
    initReels();
    initHeroVideos(e.target);
    initCarousels(e.target);
    initAutoMore();
    initScrollDots(e.target);
    $$('[data-complete-set]', e.target).forEach(initCompleteSet);
    initNav();
    initScrollers(e.target);
  });
})();
